import React, { useCallback, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import styles from "./PlaymakersGlassroots.module.scss";
import DUMMYIMAGE from "./../../assets/images/grassroots.jpg";
import useFetch from "../../hooks/useFetch";
import NewsCard from "../../components/_shared/news-card/NewsCard";
import DataNotFound from "../../components/_shared/data-not-found/DataNotFound";
import { Pagination } from "antd";

const PlaymakersGrassroots = () => {
  const { pathname, state } = useLocation();
  const [currentPage, setCurrentPage] = useState(1);

  const endpoint = `/posts/published?subCategoryId=${state?.category?.id}&childSubcategoryId=${state?.subCategory?.id}&page=${currentPage - 1}`;

  const { data, loading } = useFetch<any>(endpoint);
  const pageSize = data?.size ?? 10;

  const title = useMemo(() => {
    return pathname.substring(1);
  }, [pathname]);

  const handlePageChange = useCallback((page: number) => {
    setCurrentPage(page);
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, 100);
  }, []);

  return (
      <div className={styles.MainWrapper}>
        <div className={styles.PrimaryTitleWrapper}>
          <h1>{title}</h1>
          <h4>
            Explore our latest {title} activities and see what we've been up to.
            Stay tuned for new updates and highlights!
          </h4>
        </div>

        {data && data.content.length > 0 ? (
            <div className={styles.ContentWrapper}>
              <img src={DUMMYIMAGE} alt="" className={styles.MainImage} />

              <div className={styles.AllNews}>
                {data.content.map((newsItem: any, index: number) => (
                    <NewsCard key={index} {...newsItem} />
                ))}
              </div>

              <div className={styles.PaginationWrapper}>
                <Pagination
                    current={currentPage}
                    pageSize={pageSize}
                    total={data?.totalElements ?? 0}
                    onChange={handlePageChange}
                />
              </div>
            </div>
        ) : (
            <DataNotFound loading={loading} />
        )}
      </div>
  );
};

export default PlaymakersGrassroots;
